import { MirrorData, SetMirrorData } from '@type/job-add';
import {
  Label, Input, RecordInterface, SetFormValues,
} from '@components/common/Forms';
import { useTranslation } from 'next-i18next';
import { useJobVacancies } from '@components/templates/job-add/edit/hooks/useJobVacancies';

/** Props */
interface JobVacanciesInputProps {
  record: RecordInterface,
  setFormValues: SetFormValues,
  inputName?: string,
  labelDescriptionClass?: string,
  reqMirrorData?: Pick<MirrorData, 'vacancies' | 'addresses'>,
  setMirrorData?: SetMirrorData,
  canAutoChangeVacancies?: boolean,
}

/**
 * @description Job Vacancies component. To be used in a form.
 * - `record` - record function from useBjForm
 * - `setFormValues` - function to update the form state
 * - `inputName` - name of the input; default is 'vacancies'
 * - `labelDescriptionClass` - additional classes for the label description
 * - `reqMirrorData`: The required form mirror data.
 * - `setMirrorData` - function to update the mirror form state
 * - `canAutoChangeVacancies` - if we can auto change vacancies
 */
export const JobVacancies = (props: JobVacanciesInputProps) => {
  // Destructure props
  const {
    record,
    setFormValues,
    inputName = 'vacancies',
    labelDescriptionClass = '',
    reqMirrorData,
    setMirrorData,
    canAutoChangeVacancies,
  } = props;

  // Translation
  const { t } = useTranslation();

  // Use job vacancies hook
  const { setAutoChangeVacancies } = useJobVacancies({
    setFormValues,
    reqMirrorData,
    setMirrorData,
    canAutoChangeVacancies,
  });

  // Render
  // **************************
  return (
    <Label
      required
      description={t('job.add.label.vacancies')}
      descriptionClass={labelDescriptionClass}
    >
      <Input
        required
        type="number"
        min={1}
        max={50}
        onFocus={() => setAutoChangeVacancies(false)}
        onBlur={() => setMirrorData?.()}
        {...record(inputName)}
      />
    </Label>
  );
};
